module.exports = __webpack_public_path__ + "img/zfb.004b4481.png";